import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TablaGeneral = ({ isAdmin }) => {
  const [tablaGeneral, setTablaGeneral] = useState([]);
  const [resenaGeneral, setResenaGeneral] = useState(null);
  const [loadingResena, setLoadingResena] = useState(false);

  useEffect(() => {
    fetchTablaGeneral();
    fetchResena();
  }, []);

  const fetchTablaGeneral = async () => {
    try {
      const response = await axios.get(`${API}/estadisticas/general/all`);
      setTablaGeneral(response.data);
    } catch (error) {
      console.error('Error al obtener tabla general:', error);
    }
  };

  const fetchResena = async () => {
    try {
      const response = await axios.get(`${API}/resena/general`);
      if (response.data) {
        setResenaGeneral(response.data.resena);
      }
    } catch (error) {
      console.error('Error al obtener reseña:', error);
    }
  };

  const generarResena = async () => {
    if (!window.confirm('¿Generar reseña de la tabla general? Esto puede tardar unos segundos.')) {
      return;
    }
    
    setLoadingResena(true);
    try {
      const response = await axios.post(`${API}/resena/general/generar`);
      setResenaGeneral(response.data.resena);
      alert('✅ Reseña generada exitosamente');
    } catch (error) {
      console.error('Error al generar reseña:', error);
      alert('❌ Error al generar reseña: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoadingResena(false);
    }
  };

  const handleActualizar = async () => {
    await fetchTablaGeneral();
    
    // Generar automáticamente la reseña después de actualizar
    if (isAdmin) {
      setLoadingResena(true);
      try {
        const response = await axios.post(`${API}/resena/general/generar`);
        setResenaGeneral(response.data.resena);
        alert('✅ Tabla general y reseña actualizadas');
      } catch (error) {
        console.error('Error al generar reseña:', error);
        alert('✅ Tabla actualizada (reseña no disponible)');
      } finally {
        setLoadingResena(false);
      }
    } else {
      // Si no es admin, solo actualizar tabla y cargar reseña existente
      await fetchResena();
      alert('✅ Tabla general actualizada');
    }
  };

  const getClaseZona = (index) => {
    if (index < 8) return 'zoro';
    if (index < 12) return 'zplata';
    return 'zelim';
  };

  return (
    <div className="card">
      <h2>🏆 Tabla General – Copa Tribu Apertura</h2>
      <p style={{ textAlign: 'center', marginBottom: '15px', fontStyle: 'italic' }}>
        Suma de todas las categorías (2018, 2017, 2016, 2015, 2014, 2013, 2012)
      </p>

      <div style={{ marginBottom: '15px', textAlign: 'center' }}>
        <button className="success" onClick={handleActualizar} data-testid="actualizar-tabla-general-btn" disabled={loadingResena}>
          {loadingResena ? '⏳ Actualizando...' : '🔄 Actualizar Tabla General y Reseña'}
        </button>
      </div>

      {resenaGeneral && (
        <div style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '10px',
          marginBottom: '20px',
          border: '2px solid #0055A4'
        }}>
          <h3 style={{color: '#0055A4', marginBottom: '15px'}}>📰 Reseña de la Tabla General</h3>
          <p style={{lineHeight: '1.8', textAlign: 'justify', whiteSpace: 'pre-wrap'}}>
            {resenaGeneral}
          </p>
        </div>
      )}

      <div style={{ overflowX: 'auto' }}>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Equipo</th>
              <th>PJ</th>
              <th>PG</th>
              <th>PE</th>
              <th>PP</th>
              <th>GF</th>
              <th>GC</th>
              <th>DG</th>
              <th>PTS</th>
            </tr>
          </thead>
          <tbody>
            {tablaGeneral.map((est, index) => {
              const dg = est.gf - est.gc;
              return (
                <tr key={est.equipo} className={getClaseZona(index)} data-testid={`equipo-general-${index}`}>
                  <td>{index + 1}</td>
                  <td><strong>{est.equipo}</strong></td>
                  <td>{est.pj}</td>
                  <td>{est.pg}</td>
                  <td>{est.pe}</td>
                  <td>{est.pp}</td>
                  <td>{est.gf}</td>
                  <td>{est.gc}</td>
                  <td>{dg}</td>
                  <td><strong>{est.pts}</strong></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <p style={{ marginTop: '20px', textAlign: 'center', fontWeight: 'bold' }}>
        🟡 Copa de Oro (1–8) · ⚪ Copa de Plata (9–12) · 🔴 Eliminados (13–14)
      </p>
    </div>
  );
};

export default TablaGeneral;